import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import ReactDOM from "react-dom";
// import React from "react";
// import { createRoot } from "react-dom/client";
const localDataString = localStorage.getItem("sessionData");
setSessionData(localDataString);
// import "./apis/mock/index";
import "./bootstrap.scss";
import { queryClient } from "./config/react-query";
import "./global.scss";
import "./react-grid-layout.css";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { persistor, store } from "./redux/store";
import { getCurrentDomainPath, getEnvironmentVariableOrEmpty, } from "./utils/methods";
import { SESSION_KEYS, getDataFromSession, setSessionData, } from "./utils/session-storage";
// import { solace } from "./utils/solace-web-socket-warapper";
import { addApxor } from "./utils/apxor";
const { REACT_APP_ENV, REACT_APP_VERSION } = process.env;
const addSite24x7Script = () => {
    const existingScript = document.getElementById("site24x7");
    if (!existingScript) {
        const script = document.createElement("script");
        script.type = "application/javascript";
        script.id = "site24x7";
        script.src = `${getEnvironmentVariableOrEmpty(getCurrentDomainPath())}site24script.js`;
        document.body.appendChild(script);
    }
};
const addCleverTap = () => {
    const existingScript = document.getElementById("clevertap");
    if (!existingScript) {
        const script = document.createElement("script");
        script.type = "application/javascript";
        script.id = "clevertap";
        script.src = `${getEnvironmentVariableOrEmpty(getCurrentDomainPath())}clevertap.js`;
        document.body.appendChild(script);
        script.addEventListener("load", (callBackevent) => {
            const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
            if (window.clevertap && clientCode)
                window.clevertap.onUserLogin.push({
                    Site: {
                        Identity: clientCode, // String or number
                    },
                });
        });
    }
};
const addLoggly = () => {
    const existingScript = document.getElementById("loggly-tracker");
    if (!existingScript) {
        const script = document.createElement("script");
        script.type = "application/javascript";
        script.id = "loggly-tracker";
        script.src = `https://cloudfront.loggly.com/js/loggly.tracker-2.2.4.min.js`;
        document.body.appendChild(script);
        script.addEventListener("load", (callBackevent) => {
            //initLoggly();
        });
    }
};
if (REACT_APP_ENV == "production") {
    addSite24x7Script();
    addCleverTap();
    //addLoggly();
    addApxor();
    Sentry.init({
        dsn: "https://676d010989b846b59b02cb958cdca640@o1309377.ingest.sentry.io/6555437",
        integrations: [new BrowserTracing(), new Sentry.Replay()],
        // integrations: [new BrowserTracing()],
        ignoreErrors: [
            "Non-Error exception captured",
            "Non-Error promise rejection captured",
        ],
        release: REACT_APP_VERSION,
        replaysOnErrorSampleRate: 1.0,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}
else {
    //addLoggly();
    //solaceConnect();
    // solace("prod/marketfeed/20depth/v1/nc2885", "subscribeData");
    // solaceGreeks("prod/marketfeed/optiongreeks/g4321", "subscribe");
    //solaceGreeks("uat/marketfeed/optiongreeks/v1/88199", "subscribe");
    // if (REACT_APP_ENV == "staging") {
    //   addLoggly();
    //   addCleverTap();
    // }
    // addCleverTap();
}
// const root = createRoot(document.getElementById("root")!); // createRoot(container!) if you use TypeScript
// root.render(
//   <QueryClientProvider client={queryClient}>
//     <Provider store={store}>
//       <PersistGate persistor={persistor} loading={null}>
//         <BrowserRouter>
//           <App />
//         </BrowserRouter>
//       </PersistGate>
//     </Provider>
//   </QueryClientProvider>
// );
ReactDOM.render(_jsx(QueryClientProvider, Object.assign({ client: queryClient }, { children: _jsx(Provider, Object.assign({ store: store }, { children: _jsx(PersistGate, Object.assign({ persistor: persistor, loading: null }, { children: _jsx(BrowserRouter, Object.assign({ basename: "/fno360-guest" }, { children: _jsx(App, {}) })) })) })) })), document.getElementById("root"));
